// ─────────────────────────────────────────────────────────────────────────────
// RoleAccessStep.js — step 2. Team + Role selects, then a list of role cards
// that mirror the Role select (clicking a card selects that role).
// ─────────────────────────────────────────────────────────────────────────────
import styles from "../InviteModal.module.css";
import { TEAM_OPTIONS, ROLE_OPTIONS } from "../inviteData";
import { ChevronDownIcon } from "../icons";

export default function RoleAccessStep({ form, update }) {
  return (
    <>
      <div className={styles.field}>
        <label className={styles.label}>Team <span className={styles.req}>*</span></label>
        <div className={styles.selectWrap}>
          <select
            className={`${styles.select} ${form.team ? "" : styles.selectPlaceholder}`}
            value={form.team}
            onChange={(e) => update({ team: e.target.value })}
          >
            <option value="" disabled>Team</option>
            {TEAM_OPTIONS.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
          <span className={styles.selectChevron}><ChevronDownIcon /></span>
        </div>
      </div>

      <div className={styles.field}>
        <label className={styles.label}>Role <span className={styles.req}>*</span></label>
        <div className={styles.selectWrap}>
          <select
            className={`${styles.select} ${form.role ? styles.selectFilled : styles.selectPlaceholder}`}
            value={form.role}
            onChange={(e) => update({ role: e.target.value })}
          >
            <option value="" disabled>Role</option>
            {ROLE_OPTIONS.map((r) => <option key={r.value} value={r.value}>{r.value}</option>)}
          </select>
          <span className={styles.selectChevron}><ChevronDownIcon /></span>
        </div>
      </div>

      <div className={styles.roleList}>
        {ROLE_OPTIONS.map((r) => (
          <button
            key={r.value}
            className={`${styles.roleCard} ${form.role === r.value ? styles.roleCardActive : ""}`}
            onClick={() => update({ role: r.value })}
          >
            <div className={styles.roleName}>{r.value}</div>
            <div className={styles.roleDesc}>{r.description}</div>
          </button>
        ))}
      </div>
    </>
  );
}
